<template>
    <p class="text-red-500 text-xs"><slot></slot></p>
</template>